<lib-sidebar
  [sidebarConfig]="sidebarConfig"
  [sidebarItems]="sidebarItems()()"
  [redirectToRoute]="redirectToRoute"
  [environment]="env"
  [application]="application"
  [theme$]="theme$"
  [userProfile]="{appsAvailable: []}"
></lib-sidebar>
